import SidebarAndPanesWithRouting from '@/components/layouts/SidebarAndPanesWithRouting.vue';
import Overview from './children/Overview.vue';
import Questions from './children/Questions.vue';
import Documents from './children/Documents.vue';

const rootRoute = {
  path: 'smart_assist',
  name: 'SmartAssist',
  component: SidebarAndPanesWithRouting,
  meta: {
    auth: true,
    label: 'Smart Assist',
  },
  props: {
    baseResource: '/metrics/smart_assist',
    singleRouterView: true,
  },
};

const commonChildMeta = {
  auth: true,
  resource: rootRoute.path,
  parentName: rootRoute.name,
};

const childRoutes = [
  {
    path: 'overview',
    name: 'Metrics.SmartAssist.Overview',
    component: Overview,
    meta: {
      label: 'Overview',
      ...commonChildMeta,
    },
  },
  {
    path: 'questions',
    name: 'Metrics.SmartAssist.Questions',
    component: Questions,
    meta: {
      label: 'Questions',
      ...commonChildMeta,
    },
  },
  {
    path: 'documents',
    name: 'Metrics.SmartAssist.Documents',
    component: Documents,
    meta: {
      label: 'Resources',
      ...commonChildMeta,
    },
  },
];

rootRoute.props.children = childRoutes;

export default {
  ...rootRoute,
  children: childRoutes,
};
